module.exports = __webpack_public_path__ + "img/logo.0413bd7f.png";